import { render } from "./CreatePreOperation.vue?vue&type=template&id=08883c0d&scoped=true"
import script from "./CreatePreOperation.vue?vue&type=script&lang=js"
export * from "./CreatePreOperation.vue?vue&type=script&lang=js"

import "./CreatePreOperation.vue?vue&type=style&index=0&id=08883c0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08883c0d"]])

export default __exports__